"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.underlayStyle = exports.ModalHeaderCloseButton = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalContent = exports.ModalBody = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _zIndices = _interopRequireDefault(require("../zIndices"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = _styledComponents.default.div.withConfig({
  displayName: "modalStyles__ModalBody",
  componentId: "qdlrsu-0"
})(["padding:1rem;"]);

exports.ModalBody = ModalBody;
var mediumScreenMaxWidth = {
  small: 300,
  medium: 500,
  large: 500,
  xlarge: 500
};
var largeScreenMaxWidth = {
  small: 300,
  medium: 500,
  large: 800,
  xlarge: 800
};
var extraLargeScreenMaxWidth = {
  small: 300,
  medium: 500,
  large: 800,
  xlarge: 1360
};

var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "modalStyles__ModalContent",
  componentId: "qdlrsu-1"
})(["width:calc(100vw - 2em);border:1px solid #c8c8c8;border-radius:5px;background:#fafafa;font-size:1rem;@media (min-width:576px){max-width:", "px;}@media (min-width:992px){max-width:", "px;}@media (min-width:1400px){max-width:", "px;}"], function (props) {
  return mediumScreenMaxWidth[props.size];
}, function (props) {
  return largeScreenMaxWidth[props.size];
}, function (props) {
  return extraLargeScreenMaxWidth[props.size];
});

exports.ModalContent = ModalContent;

var ModalFooter = _styledComponents.default.footer.withConfig({
  displayName: "modalStyles__ModalFooter",
  componentId: "qdlrsu-2"
})(["display:flex;justify-content:flex-end;padding:1rem;border-top:1px solid #e9ecef;"]);

exports.ModalFooter = ModalFooter;

var ModalHeader = _styledComponents.default.header.withConfig({
  displayName: "modalStyles__ModalHeader",
  componentId: "qdlrsu-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:1rem;border-bottom:1px solid #e9ecef;"]);

exports.ModalHeader = ModalHeader;

var ModalTitle = _styledComponents.default.h2.withConfig({
  displayName: "modalStyles__ModalTitle",
  componentId: "qdlrsu-4"
})(["margin:0;"]);

exports.ModalTitle = ModalTitle;

var ModalHeaderCloseButton = _styledComponents.default.button.withConfig({
  displayName: "modalStyles__ModalHeaderCloseButton",
  componentId: "qdlrsu-5"
})(["padding:1rem;border:none;margin:-1rem -1rem -1rem auto;appearance:none;background:none;color:#0008;cursor:pointer;font-size:16px;&:focus{color:#000;}&:hover{color:#000;}"]);

exports.ModalHeaderCloseButton = ModalHeaderCloseButton;
var underlayStyle = {
  boxSizing: 'border-box',
  padding: '2em 0',
  zIndex: _zIndices.default.modal
};
exports.underlayStyle = underlayStyle;